import { translate } from '@utils/i18n';
import { IKeyValueType } from '../KeyValueList';
import { namespace as parentNamespace } from '../../constants';
const namespace = `${parentNamespace}.tabs.detail`;
export function getGeneralInfo(deficiency) {
    var _a, _b, _c, _d, _e, _f;
    return [
        deficiency.question || deficiency.displayName
            ? {
                key: translate('question', { namespace }),
                value: (_a = (deficiency.question || deficiency.displayName)) !== null && _a !== void 0 ? _a : 'No question available',
                type: IKeyValueType.text
            }
            : undefined,
        {
            key: translate('answer', { namespace }),
            value: (_b = deficiency.answer) !== null && _b !== void 0 ? _b : 'No answer available',
            type: IKeyValueType.text
        },
        deficiency.isResolved
            ? {
                key: translate('resolution_date', { namespace }),
                editable: true,
                value: (_c = deficiency.dateResolved) !== null && _c !== void 0 ? _c : 'Not resolved',
                type: IKeyValueType.date,
                field: 'dateResolved'
            }
            : undefined,
        deficiency.isResolved
            ? {
                key: translate('resolved_by', { namespace }),
                value: deficiency.resolvedTechnicianName,
                field: 'resolvedTechnicianName',
                editable: true,
                type: IKeyValueType.text
            }
            : undefined,
        {
            key: translate('building', { namespace }),
            value: `/buildings/${deficiency.building.id}`,
            label: deficiency.building.name,
            type: IKeyValueType.link
        },
        deficiency.building.address
            ? {
                key: translate('address', { namespace }),
                value: (_d = deficiency.building.address) !== null && _d !== void 0 ? _d : 'No address available',
                type: IKeyValueType.address
            }
            : undefined,
        {
            key: translate('date_opened', { namespace }),
            value: (_e = deficiency.dateOpened) !== null && _e !== void 0 ? _e : 'Not resolved',
            type: IKeyValueType.date
        },
        {
            key: translate('last_recorded_deficient', { namespace }),
            value: (_f = deficiency.lastRecordedDeficient) !== null && _f !== void 0 ? _f : 'Not available',
            type: IKeyValueType.date
        }
    ].filter(Boolean);
}
export function getAssetsInfo(deficiency) {
    return Object.entries(deficiency.assetDetails).map(([key, value]) => ({
        key,
        value: value !== null && value !== void 0 ? value : 'N/A',
        type: IKeyValueType.text
    }));
}
